import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatDatepickerModule, MatDialogModule, MatInputModule, MatNativeDateModule, MatSelectModule, MatSlideToggleModule, MatTooltipModule } from '@angular/material';
import { DisableControlDirective } from 'app/directives/disable-control.directive';
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll'; // per il componente custom datepicker
import { CUSTOM_ERRORS } from '../../custom-global-errors';
import { ImagePreview } from '../../directives/image-preview.directive';
import { ForFilterDefServizioPipe, ForFilterScontoProfiloPipe, ForFilterScontoTipoProfiloPipe } from '../../pipes/for-filter.pipe';
import { RiferimentoFormatPipe } from '../../pipes/riferimento-format.pipe';
import { SecureUrlPipe } from '../../pipes/secureUrl.pipe';
import { ArraySortPipe } from '../../pipes/sort-definizione-servizio.pipe';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DialogCambiaPassword } from './dialogs/dialog-cambia-password/dialog-cambia-password.component';
import { DialogConfermaInputComponent } from './dialogs/dialog-conferma-input/dialog-conferma-input.component';
import { DialogConfermaOrario } from './dialogs/dialog-conferma-orario/dialog-conferma-orario.component';
import { DialogConfermaComponent } from './dialogs/dialog-conferma/dialog-conferma.component';
import { DialogImmobileCambiaStato } from './dialogs/dialog-immobile-cambia-stato/dialog-immobile-cambia-stato.component';
import { DialogImmobileCancellazioneLogica } from './dialogs/dialog-immobile-cancellazione-logica/dialog-immobile-cancellazione-logica.component';
import { DialogImmobileSospeso } from './dialogs/dialog-immobile-sospeso/dialog-immobile-sospeso.component';
import { DialogInfoAbbilitazioneCookieComponent } from './dialogs/dialog-info-abbilitazione-cookie/dialog-info-abbilitazione-cookie.component';
import { DialogInfoCapacitaSpesaDichiarazione } from './dialogs/dialog-info-capacita-spesa-dichiarazione/dialog-info-capacita-spesa-dichiarazione.component';
import { DialogInfoCapacitaSpesaValore } from './dialogs/dialog-info-capacita-spesa-valore/dialog-info-capacita-spesa-valore.component';
import { DialogInfoPolizzaAssicurativa } from './dialogs/dialog-info-polizza-assicurativa/dialog-info-polizza-assicurativa.component';
import { DialogInviaMessaggioServizio } from './dialogs/dialog-invia-messaggio-servizio/dialog-invia-messaggio-servizio.component';
import { DialogInviaMessaggioPrenotazione } from './dialogs/dialog-invia-messaggio-prenotazione/dialog-invia-messaggio-prenotazione.component';
import { DialogNotificaComponent } from './dialogs/dialog-notifica/dialog-notifica.component';
import { DialogPolizzaAssicurativa } from './dialogs/dialog-polizza-assicurativa/dialog-polizza-assicurativa.component';
import { DialogProfiloCancellazioneLogica } from './dialogs/dialog-profilo-cancellazione-logica/dialog-profilo-cancellazione-logica.component';
import { ShowHidePassword } from './show-hide-password/show-hide-password.component';
import { StarRatingComponent } from './start-rating/start-rating.component';
import { DialogInviaMessaggio } from './dialogs/dialog-invia-messaggio/dialog-invia-messaggio.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgBootstrapFormValidationModule.forRoot(CUSTOM_ERRORS),
        MatAutocompleteModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatDialogModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatSelectModule,
        NgSlimScrollModule
    ],
    entryComponents: [
        DialogInviaMessaggio,
        DialogInviaMessaggioPrenotazione,
        DialogConfermaOrario,
        DialogInviaMessaggioServizio,
        DialogImmobileCambiaStato,
        DialogCambiaPassword,
        DialogInfoPolizzaAssicurativa,
        DialogInfoCapacitaSpesaValore,
        DialogInfoCapacitaSpesaDichiarazione,
        DialogNotificaComponent,
        DialogConfermaComponent,
        DialogConfermaInputComponent,
        DialogPolizzaAssicurativa,
        DialogInfoAbbilitazioneCookieComponent,
        DialogImmobileSospeso,
        DialogProfiloCancellazioneLogica,
        DialogImmobileCancellazioneLogica
    ],
    declarations: [
        ShowHidePassword,
        RiferimentoFormatPipe,
        ImagePreview,
        DisableControlDirective,
        SecureUrlPipe,
        ForFilterDefServizioPipe,
        ForFilterScontoProfiloPipe, 
        ForFilterScontoTipoProfiloPipe,
        ArraySortPipe,
        DialogInviaMessaggio,
        DialogInviaMessaggioPrenotazione,
        DialogImmobileCambiaStato,
        DialogConfermaOrario,
        DialogInviaMessaggioServizio,
        DialogCambiaPassword,
        StarRatingComponent,
        DialogInfoPolizzaAssicurativa,
        DialogInfoCapacitaSpesaValore,
        DialogInfoCapacitaSpesaDichiarazione,
        DialogNotificaComponent,
        DialogConfermaComponent,
        DialogConfermaInputComponent,
        DialogPolizzaAssicurativa,
        DialogInfoAbbilitazioneCookieComponent,
        DatepickerComponent,
        DialogImmobileSospeso,
        DialogProfiloCancellazioneLogica,
        DialogImmobileCancellazioneLogica
    ],
    providers: [
        {
            provide: SLIMSCROLL_DEFAULTS,
            useValue: {
                alwaysVisible : false
            }
        }
    ],
    exports: [
        DatepickerComponent,
        NgSlimScrollModule,
        ShowHidePassword,
        RiferimentoFormatPipe,
        ImagePreview,
        DisableControlDirective,
        SecureUrlPipe,
        ForFilterDefServizioPipe,
        ForFilterScontoProfiloPipe, 
        ForFilterScontoTipoProfiloPipe,
        ArraySortPipe,
        DialogInviaMessaggioPrenotazione,
        DialogImmobileCambiaStato,
        DialogConfermaOrario,
        DialogInviaMessaggioServizio,
        StarRatingComponent,
        DialogConfermaComponent,
        DialogConfermaInputComponent,
        DialogPolizzaAssicurativa,
        DialogInfoAbbilitazioneCookieComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UtilitaModule { } 


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/utilita.module.ts